<script setup lang="ts">
const props = defineProps<{
  isHover?: boolean
  class?: string
}>()
</script>

<template>
  <div :class="[$style.actions]">
    <slot />
    <nav
      flex
      items-center
      bg-transparent
      px-1
      :class="[$style.actions__hidden, {
        '!opacity-100': props.isHover,
      }, props.class]"
    >
      <slot name="actions" />
    </nav>
  </div>
</template>

<style module lang="scss">
.actions {
  @apply flex
  gap-.5
  justify-self-end
  ml-auto
  z-10
  items-center;
  pointer-events: none;

  .actions__hidden {
    pointer-events: auto;
    background-color: #fff;
  border-radius: 8px;
  border: 1px solid #E3E9F8;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
  }
}
.actions__hidden {

  @apply opacity-0 items-center transition-opacity duration-300;
}
</style>
